import React, { useEffect, useState } from "react";
import ImageListComponent from "../components/suites/ImageList";
import SuitsDescription from "../components/suites/SuitsDescription";
import SuitesDetail from "../components/suites/SuitesDetail";
import Container from "../components/Container";
import Amenities from "../components/suites/Amenities";
import Price from "../components/suites/Price";
import OtherSuites from "../components/suites/OtherSuites";
import image from "../assets/TropicalSuiteImg/TS14.jpg";
import TopBannerSection from "../components/TopBannerSection";
import MobileImageList from "../components/suites/MobileImageList";

const TheTropicalSuite = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container>
      <TopBannerSection Image={image} Quote={"The Tropical Suite"} />
      <br />
      {isDesktop ? <ImageListComponent /> : <MobileImageList />}
      <SuitsDescription />
      <SuitesDetail />
      <Amenities />
      <Price />
      <OtherSuites />
    </Container>
  );
};

export default TheTropicalSuite;
